export default {"src":"/_next/static/media/solar_buildings-linear2.402bb842.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};